import React, {
  ReactChild,
} from 'react'
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const StyledPageBreadcrumb = styled(Breadcrumb)`
  .breadcrumb {
    background-color: white;
    text-align: left;
    margin-left: 0;
    margin-bottom: 5px;
    padding-left: 0;
    padding: 0;
  }
`

const StyledPageBreadcrumbItem = styled(BreadcrumbItem)`
`

const StyledLink = styled(Link)`
  font-family: Poppins;
  font-weight: 600;
  font-size: 12px;
  color: #276FFA;
  letter-spacing: 0;
  background-color: white;
  text-align: left;
  margin-left: 0;
  padding-left: 0;
`

export interface PageBreadcrumbsProps {
  children?: ReactChild,
  routeTo?: String,
}

/**
 * PageBreadcrumbs acts and is styled as a single back link, but
 * in the future it will be used as a multi page depth breadcrumb list
 */
const PageBreadcrumbs: React.SFC<PageBreadcrumbsProps> = (props) => (
  <StyledPageBreadcrumb>
    <StyledPageBreadcrumbItem>
      <FontAwesomeIcon icon="chevron-left" color="#276FFA" transform="shrink-3 down-1" className="mr-1" />
      <StyledLink to={props.routeTo}>{props.children}</StyledLink>
    </StyledPageBreadcrumbItem>
  </StyledPageBreadcrumb>
)

export default PageBreadcrumbs
